
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Pagination } from 'element-ui'
Vue.use(Pagination)
@Component({
  components: {}
})
export default class MainSection extends Vue {
  @Prop() private total!: number
  @Prop() private page_size!: number
  @Prop() private page_num!: number

  handleCurrentChange (val: number) {
    this.$emit('handleCurrentChange', val)
  }

  handleSizeChange (val: number) {
    this.$emit('handleSizeChange', val)
  }
}
